import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 544px;
	margin: auto;
	padding: 0 2em;

	.layout-forms-input {
		&:first-of-type {
			margin-bottom: 2em;
		}

		.label-wrapper {
			.label-body {
				.layout-forms-input-label {
					opacity: 1;
					color: black;
					transform: translate(0.6em, -0.1em);
					font-size: 1.2em;
					font-weight: 400;
				}
			}
		}

		.input-body {
			.input {
				border: 2px solid #ba9449;
				color: #ba9449;
				font-size: 1.2em;
				padding: 0.6em 0.8em;
				height: 3.2em;

				&::placeholder {
					color: #ba9449;
					opacity: 0.4;
				}
			}
		}
	}

	.inputs-additions {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		padding: 1em 0.6em;

		.password-reset {
			width: 100%;
			justify-content: flex-end;
			padding-top: 0.3em;

			.button {
				.button-content {
					font-size: 15px;
				}
				&:hover {
					.button-content {
						font-weight: unset;
					}
				}
			}
		}

		.checkbox-wrapper {
			.checkbox-trigger {
				&::after {
					max-width: 18px;
					margin: 6px 0 0 1px;
				}
			}
		}
	}

	.form-control {
		&.layout-button {
			width: 220px;
			margin: 0 auto 1em;

			.button {
				font-size: 1.25em;
				padding: 0.5em;
				border-radius: 5px;
			}
		}
	}

	.form-footer {
		position: absolute;
		bottom: 1.5em;
		left: 50%;
		transform: translateX(-50%);

		margin: 3em auto 0 auto;
		font-size: 0.75em;
		width: max-content;

		.footer-link {
			color: #ba9449;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		&.no-absolute {
			position: unset;
			transform: unset;
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		padding: 0.4em 0;

		.form-control {
			&.layout-button {
				margin: 0 auto 4em;
			}
		}

		.form-footer {
			max-width: 300px;
		}
	}
`;
